function splitNavigation(carousel) {
    let arrowLeft = document.querySelector('#split-right .arrow--prev')
    let arrowRight = document.querySelector('#split-right .arrow--next')
  
    function arrows() {  
      arrowLeft.addEventListener("click", () => {
        carousel.prev()
      })
      arrowRight.addEventListener("click", () => {
        carousel.next()
      })
    }

    function updateIndex() {
        var slide = carousel.track.details.rel
        let currentSlide = slide + 1
        let currentSlideWrapper = document.querySelector('#split-right .carousel-pagination__active')

        currentSlideWrapper.innerHTML = currentSlide
    }
  
    carousel.on("created", () => {
      arrows()
      updateIndex()
    })
    carousel.on("optionsChanged", () => {
      arrows()
      updateIndex()
    })
    carousel.on("slideChanged", () => {
        updateIndex()
    })
    carousel.on("destroyed", () => {
      arrows()
    })
}

function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active");
        });
      }
      function addActive(idx) {
        slider.slides[idx].classList.add("active");
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx);
          });
        });
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel);
        addClickEvents();
        main.on("animationStarted", (main) => {
          removeActive();
          const next = main.animator.targetIdx || 0;
          addActive(main.track.absToRel(next));
          slider.moveToIdx(next);
        });
      });
    };
}

var splitRight = new KeenSlider("#split-right")

var splitLeft = new KeenSlider("#split-left", 
    {
        loop: true,
        drag: false,
        slides: {
            origin: "center",
            perView: 1,
            spacing: 0,
            duration: 600,
        },
    },
    [ThumbnailPlugin(splitRight), splitNavigation]
)

var splitRight = new KeenSlider("#split-right", 
    {
        loop: true,
        drag: false,
        slides: {
            origin: "center",
            perView: 1,
            spacing: 0,
            duration: 600,
        },
    }, [ThumbnailPlugin(splitLeft), splitNavigation])